$(".custom-slider").slick({
  
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  rtl: true,
  prevArrow: `<button class="custom-slick-prev arrow-buttons"><img src="https://cdn.shopify.com/s/files/1/0519/4055/6973/files/arrow-right-333-svgrepo-com_430x.svg?v=1685196688"></button>`,
  nextArrow: `<button class="custom-slick-next arrow-buttons"><img src="https://cdn.shopify.com/s/files/1/0519/4055/6973/files/arrow-right-333-svgrepo-com_430x.svg?v=1685196688"></button>`,

  // the magic
  responsive: [{

      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        
      }

    }, {

      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      }

    }
    , 
    {

      
      breakpoint: 576,
      settings: {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        arrows: false,
      }
    }]
});
